import { Request } from "./Request";

export interface LanguageCourseDecision {
  id: number;
  requestId: number;
  decision?: string;
  isConsentSent: boolean;
  languageCourseOptionId: LanguageCourseOption;

  ministryDecision?: string;
  ministryExplanation?: string;

  consentStatusId?: LanguageCourseDecisionConsentStatus;

  institutionId?: number;

  request?: Request;
}

export enum LanguageCourseOption {
  /// <summary>
  /// Uključivanje učenika u dopunsku nastavu hrvatskog jezika
  /// </summary>
  SupplementaryCourse = 1,
  /// <summary>
  /// Uključivanje učenika u pripremnu nastavu hrvatskog jezika
  /// </summary>
  PreparatoryCourse,
  /// <summary>
  /// Upis u školu bez pripremne/dopunske nastave hrvatskog jezika
  /// </summary>
  NotRequired,
}

export enum LanguageCourseDecisionConsentStatus {
  /// <summary>
  /// Daje suglasnost za pripremnu nastavu hrvatskoga jezika
  /// NovaSkola = 0
  /// </summary>
  PreparatoryCourseApproved = 1,
  /// <summary>
  /// Ne daje suglasnost za pripremnu nastavu hrvatskoga jezika
  /// NovaSkola = 0
  /// </summary>
  PreparatoryCourseRejected,
  /// <summary>
  /// Daje suglasnost za dopunsku nastavu hrvatskoga jezika
  /// NovaSkola = 0
  /// </summary>
  SupplementaryCourseApproved,
  /// <summary>
  /// Ne daje suglasnost za dopunsku nastavu hrvatskoga jezika
  /// NovaSkola = 0
  /// </summary>
  SupplementaryCourseRejected,
}
